var _path, _path2, _path3, _path4, _path5, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clipPath--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.59,331.88v16.41c0,1.23-.86,1.73-1.93,1.12l-17.23-9.82a4.26,4.26,0,0,1-1.93-3.34V319.84c0-1.23.87-1.73,1.93-1.11,4.7,2.71,12.53,7.1,17.23,9.81A4.26,4.26,0,0,1,376.59,331.88Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-17",
    cx: 250,
    cy: 345.6,
    rx: 223.87,
    ry: 137,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.78,277.92l8-4.35s4.23-20.8,1.78-38.82c-3.45-25.32-20.45-34.4-26.75-32s-7.92,9.82,3,24.65C57.32,236.13,65.49,254.5,64.78,277.92Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.78,277.92l8-4.35s4.23-20.8,1.78-38.82c-3.45-25.32-20.45-34.4-26.75-32s-7.92,9.82,3,24.65C57.32,236.13,65.49,254.5,64.78,277.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,267.52h-.08a.56.56,0,0,1-.5-.62c2.54-23.73-7.75-49.32-18.75-59.43a.56.56,0,0,1,0-.79.57.57,0,0,1,.8,0C62.08,216.93,72.57,242.94,70,267A.56.56,0,0,1,69.45,267.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3,295.64c-1.19.82-3.88-.55-4.91-1.13a11.94,11.94,0,0,1-4.3-4.23,11.17,11.17,0,0,1-1.51-6.62,26.2,26.2,0,0,1,.57-3.62c.24-1.17.49-2.35.73-3.53a8.75,8.75,0,0,0,.23-3.52c-.48-2.34-2.7-3.83-4.72-5.11-2.23-1.41-4.58-3.32-4.79-6.17a10,10,0,0,1,2-6.14c1.22-1.83,2.72-3.47,3.8-5.39a6.9,6.9,0,0,0,1.09-4.52A7.33,7.33,0,0,0,33.37,243c-1.15-1.77-2.6-3.36-3.45-5.3s-.94-4.41.51-6c1.18-1.26,3.06-1.57,4.79-1.59a11.22,11.22,0,0,1,4.68,1.25c4.7,2.16,7.69,7.31,12.63,8.87a48.38,48.38,0,0,0,5.9,1c2,.36,4,1.19,5,2.9,2,3.37-.9,7.95.63,11.58,1.35,3.22,4.65,4.23,6.68,7.07A7.1,7.1,0,0,1,71.94,267a20.79,20.79,0,0,1-1.26,7.43A58.87,58.87,0,0,1,68,280.5C67.93,280.58,46.48,295.52,46.3,295.64Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.57,287.84h0a.56.56,0,0,1-.59-.54c-.8-22.38-13.21-46.19-21.4-52.76a.56.56,0,0,1,.7-.88c8.36,6.7,21,30.91,21.83,53.6A.57.57,0,0,1,58.57,287.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.19,261.74a.33.33,0,0,1-.17,0,76.09,76.09,0,0,0-16.39-1.36.56.56,0,0,1-.58-.54.54.54,0,0,1,.54-.58,76.59,76.59,0,0,1,16.68,1.38.57.57,0,0,1,.42.68A.54.54,0,0,1,53.19,261.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.79,290.84l-9.3-5.89s-4.56-17.58-5.39-33.25c-1.17-22,7.28-50.32,24.93-46.74s-3.37,29.39-6,48.62S448.79,290.84,448.79,290.84Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.79,290.84l-9.3-5.89s-4.56-17.58-5.39-33.25c-1.17-22,7.28-50.32,24.93-46.74s-3.37,29.39-6,48.62S448.79,290.84,448.79,290.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.55,289.33h0a.57.57,0,0,0,.46-.66c-9-48,11.33-75.85,11.53-76.13a.57.57,0,1,0-.91-.68c-.21.28-20.81,28.58-11.74,77A.57.57,0,0,0,443.55,289.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,294.5l-7-4s-3.07-12.89,1.11-30.53c3.63-15.35,16.29-29.56,24-28.15s8.28,6.61,5.55,12.57S454.9,267.13,454,294.5Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.63,293h0a.57.57,0,0,0,.48-.65c-4.77-30.46,20.71-55.41,21-55.66a.57.57,0,0,0,0-.81.58.58,0,0,0-.81,0c-.26.25-26.16,25.62-21.3,56.66A.57.57,0,0,0,450.63,293Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-17",
    cx: 167.72,
    cy: 372.71,
    rx: 79.6,
    ry: 45.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-17",
    d: "M337.11,434.94a9.63,9.63,0,0,1-7-2.85L229.43,326.63a23.62,23.62,0,0,1-6.7-16.31,22.57,22.57,0,0,1,.23-3.18,23.35,23.35,0,0,1,11.69-16.87l3-1.73a34.67,34.67,0,0,1,32.82,0L411.64,370l7.49,4.27a5.56,5.56,0,0,1,0,10.17l-8.94,5.09a14.32,14.32,0,0,1-6.89,1.65h0a13.17,13.17,0,0,1-4.69-.8L277.76,343.2l72.5,75.92a6.68,6.68,0,0,1-1.61,10.75l-7,3.94A9.18,9.18,0,0,1,337.11,434.94Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.4,108.86c9.19-.62,13.64,2.37,17.59,7.14s22.55,38.18,22.55,38.18,38.59,1,45.94,3.32,11.51,6.47,13,9,1.86,5.65.86,9.77-6.61,3.26-9.62,0a39,39,0,0,0-9.51-7.46c-3.15-1.78-34.3.42-42.78.51s-10.07-3.43-15.27-10.47-16.43-23.45-16.43-23.45Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64,108.72c8.26-.68,13.75-.17,18.49,4.39S211,146.57,211,146.57s-2.23,9.14-15.91,11.16L174.4,130Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.29,362.73c3.47,2,7.39,2,11.65.34l2.82-22.86L129,336.83Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.56,350.3c2.79,6.55,6.87,4.41,13.07.46l.41-22.58-16-1.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,383.88c.38.37.22,3.22-.23,3.88s-3,2.87-7.79,3.07c-4.57.2-8.63-.54-11.26-2.32s-3.88-3.7-4-6.31.19-5.11-1-7.15c-1.09-1.88-2.57-3.73-2.93-4.74-.8-2.21-.16-5.59-.16-5.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,362.11a12.35,12.35,0,0,0,.47,2.91,26.11,26.11,0,0,0,2.63,5.8,23.79,23.79,0,0,0,1.82,2.75c1.34,1.68,3,3.08,4.43,4.7A9.36,9.36,0,0,1,154.6,384c.09,3.59-3.84,4.69-6.85,5.13a22,22,0,0,1-9.71-.77,8.93,8.93,0,0,1-6.33-7.34c-.14-1-.05-2-.14-3a14.12,14.12,0,0,0-2.59-6.35,18.53,18.53,0,0,1-2-3.48c-.87-2.24,0-4.71.62-6.9.57-1.9,1-4.17,1.67-4,0,.38,0,1.22,0,1.22.2.43.69.72.81,1.21a8.7,8.7,0,0,0,.5,1.49,3.92,3.92,0,0,0,1.54,1.8c.08-1.35.17-2.7.25-4.05a1.43,1.43,0,0,1,1.51-1.65,25.45,25.45,0,0,1,7.68-.4,1.45,1.45,0,0,1,1,.48,1.5,1.5,0,0,1,.14.92A35.07,35.07,0,0,0,142.6,362.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.16,371.59c-1.31-1-4.29-1.14-5.93-1a9.76,9.76,0,0,0-4.69,1.49,1.08,1.08,0,0,1-1.37-.15h0a1,1,0,0,1,.15-1.52,10.12,10.12,0,0,1,5.28-1.78c4-.16,5.19.56,5.19.56S146.59,370.41,146.16,371.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,375.35c-1.65-1-4.94-1-6.58-.87a9.4,9.4,0,0,0-4.57,1.58,1.05,1.05,0,0,1-1.36-.14h0a1,1,0,0,1,.14-1.52,10.34,10.34,0,0,1,5.4-1.93c4-.17,5.06.68,5.06.68A3.35,3.35,0,0,1,149.12,375.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,364.72a9.94,9.94,0,0,1,5,.58c.69.42,1.13,1.55.66,1.82a9.29,9.29,0,0,0-4.46-.75,13.24,13.24,0,0,0-4.38,1.07c-.35.14-.77.34-1.13.53a1,1,0,0,1-1.31-.45h0a.9.9,0,0,1,.38-1.14A13,13,0,0,1,138.12,364.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16,365.31a4.35,4.35,0,0,1-.27,3.18c-.48.92-5.43,3.52-12,2.88a27.34,27.34,0,0,1-13.45-5.15c-2.45-1.73-5-2.12-8.3-2.4s-7.47-2-8.14-3.58.23-4.14.23-4.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,345.17l1.73-.57a1.42,1.42,0,0,1,1-.09c.42.17.57.67.66,1.11a17,17,0,0,0,.64,2.88,7,7,0,0,0,1.78,2,30.31,30.31,0,0,0,5.16,3.55c2.11,1.21,4.19,2.17,6.38,3.23s5.21,1.8,6.94,3c2.53,1.82,2.73,6.2-.26,7.83-2.57,1.41-9.29,2.83-16.23.64-3.77-1.19-7.88-5.39-12.87-5.93-3.17-.34-9.16-1.42-11.14-3.89-.72-1.1.39-4.46,1.31-7.37,1-3.17,1.51-8.3,2.56-8,.17,1.7.93,1.85,1.46,2.76a19.33,19.33,0,0,1,1.07,2.57,4.54,4.54,0,0,0,1.59,2.24,2.11,2.11,0,0,0,2.58-.07c1-.94.46-2.65,1.18-3.79a3.93,3.93,0,0,1,2.28-1.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.21,352.22a2.93,2.93,0,0,0-2.3-1.64c-1.44-.32-4,.67-5.65,1.94a1.18,1.18,0,0,0,.11,2h0a1.18,1.18,0,0,0,1.36-.11A9.09,9.09,0,0,1,192.21,352.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.62,354.86a3.38,3.38,0,0,0-2.74-1.51s-3.78,0-6.18,2.1a1.16,1.16,0,0,0,.1,1.9h0a1.13,1.13,0,0,0,1.31-.11A9.11,9.11,0,0,1,196.62,354.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.51,357.27a3.84,3.84,0,0,0-2.85-1.38,10.19,10.19,0,0,0-5.93,2.14,1.16,1.16,0,0,0,.1,1.9h0a1.13,1.13,0,0,0,1.31-.11A8.71,8.71,0,0,1,201.51,357.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.67,186.34c-1.57,25.06-4.12,87.77-4.12,87.77-.35,3.11-1.5,12.3-2.07,23.53-.83,16.29.47,52.25.47,52.25s6.68,3.86,13.9,1.1c0,0,9.27-53,12.23-69,2.61-14.06,7.68-48,7.68-48l2.38,41.68a133,133,0,0,0,.55,22.4c.93,7.43,5.18,39.68,5.18,39.68a28.57,28.57,0,0,0,15.17-.14s2.22-54.08,2.55-60.93c.38-7.8,2-95.43,2-95.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,234.05l4.32-20.44s10.31-.59,16.16-6.16c0,0-1.17,5.59-14.2,8.58l-4.33,20.69L164.28,256Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,111.77c-4.92.87-5.25,3.31-6.33,8.2-.53,2.42-1.73,7.64-1.25,12l2.53,29.1-1,33.06c7.93,8.63,40.47,11.37,57.78-1.27,0,0-.19-54.64-1-63.41-1.39-15.32-8.34-20.76-18.53-20.73l-17.44,1.49Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,111.77c-4.92.87-5.25,3.31-6.33,8.2-.53,2.42-1.73,7.64-1.25,12l2.53,29.1-1,33.06c7.93,8.63,40.47,11.37,57.78-1.27,0,0-.19-54.64-1-63.41-1.39-15.32-8.34-20.76-18.53-20.73l-17.44,1.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.83,73a15.48,15.48,0,1,0,15.42-15.53A15.48,15.48,0,0,0,157.83,73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,76.07l-3.3-8.88a5.81,5.81,0,0,0-4.8,1.71c-2.06,2.12-.89,8.72,1.71,15.19,0,0,2.55,11.77,3.56,13.71a5.32,5.32,0,0,0,3.09,2.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.73,84.61c-.94.57-2.3-1.24-3.47-2.46s-5-2.88-6.89,1.14,1.72,9.47,4.72,10.41C152.27,95.3,153,92,153,92l.46,18.67s3.41,8.28,12.59,9.49,7.27-6.35,4.24-10l0-5.69a32.61,32.61,0,0,0,7,.34c3.8-.6,6.18-3.61,7.32-7.74,1.84-6.62,2.52-12,.9-25-1.77-14.26-18.36-14.35-27.3-8.68S152.73,84.61,152.73,84.61Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.83,85.86c-1.5-.43-2.59-2.82-3.57-3.71-1.64-1.48.42-15,.42-15s-1.58-3.34,1.55-6.81c2.23-2.47,6-2.76,12.36-3.79,3.15-.5,6.86-.75,10-1.33a31.76,31.76,0,0,0,9.29-3,2.8,2.8,0,0,1,1.77-.46,1.67,1.67,0,0,1,1.12.94,3.18,3.18,0,0,1,.26,1.47,5.86,5.86,0,0,1-.27,1.55c-.1.3-.71,1.21-.58,1.47.32.65,2.78-.44,3.27-.59a.38.38,0,0,1,.56.21,6,6,0,0,1-.29,5.18,17.52,17.52,0,0,1-8.79,7.48,24.16,24.16,0,0,1-12,1.66A23,23,0,0,1,162.82,70a14.23,14.23,0,0,1-1.12,1.75,7.85,7.85,0,0,1-1.65,1.45,7.06,7.06,0,0,1-2,.92c-.73.19-1.43.1-1.83.89a3.82,3.82,0,0,0-.3,1.65l-.15,4.94a8,8,0,0,1-.33,2.49,2.74,2.74,0,0,1-1.67,1.75A1.62,1.62,0,0,1,152.83,85.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,104.41s-8.5-1.68-11.48-3.25a9.79,9.79,0,0,1-4.12-4,13.52,13.52,0,0,0,2.35,4.79c2.18,2.77,13.26,4.77,13.26,4.77Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.67,82.74A1.7,1.7,0,1,1,167,81,1.73,1.73,0,0,1,168.67,82.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.64,77.49l-3.77,2.45a2.36,2.36,0,0,1,.69-3.19A2.2,2.2,0,0,1,166.64,77.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84,93.09l6,2.56a3.31,3.31,0,0,1-4.4,1.75A3.16,3.16,0,0,1,165.84,93.09Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,97.4a3.74,3.74,0,0,0,1.47.27,2.87,2.87,0,0,0-2.83-2.46,2.3,2.3,0,0,0-.45.05A3.06,3.06,0,0,0,167.43,97.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,79.24l-3.59-2.18a2,2,0,0,1,2.82-.76A2.21,2.21,0,0,1,183.82,79.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.45,82.73A1.7,1.7,0,1,1,180.74,81,1.73,1.73,0,0,1,182.45,82.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.48 81.85 173.75 92.81 179.52 91.03 173.48 81.85",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,161.71c5.07-8,12.36-22.81,12.36-22.81,4.14-9.84,3.88-21,1.66-27.08a39,39,0,0,0-4.09.79c-7,2-9,3-12.44,8.81-2.72,4.6-11.53,27.61-14.92,34.77l-16.53-15c-3.91-3.88-4.48-9-6.8-12.37s-5.14-4.45-7.84-7.35-3.62-5-4.9-2.93,1.56,6.22,2,7.21,3.62,3.57-.9,2.84-12.57-7-14.57-8.25-2.36,1.39-1.59,3.22-.11,6.52,1.2,9.55c1.39,3.22,2.21,4.65,6.13,7.23,3.65,2.41,11.81,4.59,15.53,8s12.47,14.48,17.79,21.16c6.77,8.49,12.72,12.42,18.23,6.18C119.51,171,123.22,164.67,125.1,161.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.71,111.63c-5.61-.33-14.77.18-19.83,11.31s-12.24,29.37-12.24,29.37,8.52,11.26,17.75,10.25l13.93-26.41S144.33,122.29,140.71,111.63Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wallet--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.08,381.54a3,3,0,0,0,1.27-2.8V257.41a8.85,8.85,0,0,0-1.27-4.27l7.52-4.34a8.84,8.84,0,0,1,1.27,4.26V374.4a3,3,0,0,1-1.27,2.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.08,253.14a8.83,8.83,0,0,0-3.06-3.23L262.71,170.63c-4.78-2.76-12.54-2.76-17.32,0l-3,1.73a7.7,7.7,0,0,0-4.17,6.64V310.34a7.73,7.73,0,0,1,4.17-6.65l3-1.73c4.78-2.76,12.54-2.76,17.32,0L400,381.24a2.64,2.64,0,0,0,4.33-2.5V257.41A8.85,8.85,0,0,0,403.08,253.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,181.25c-1.09-3.31.26-6.85,3.8-8.89l3-1.73c4.78-2.76,12.54-2.76,17.32,0L400,249.91a8.86,8.86,0,0,1,3.06,3.23l7.52-4.34a9,9,0,0,0-3.06-3.24L266.46,164.14c-7.07-4.09-17.74-4.09-24.82,0l-3,1.72A15.43,15.43,0,0,0,230.88,177a13.9,13.9,0,0,0-.15,2,15.66,15.66,0,0,0,4.49,10.78l5.43-5.18a8.8,8.8,0,0,1-2.05-3.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,273V256.37l-137.91-79.6a9.33,9.33,0,0,0-8.66,0l-1.5.86a3.85,3.85,0,0,0-2.08,3.32v28.77Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,273V256.37l-137.91-79.6a9.33,9.33,0,0,0-8.66,0l-1.5.86a3.85,3.85,0,0,0-2.08,3.32v28.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,173.52a13.35,13.35,0,0,0-12.41,0l-1.49.86a7.71,7.71,0,0,0-3.89,5.54,7,7,0,0,0-.07,1v4.5l3.75,3.92V181a3.84,3.84,0,0,1,2.08-3.32l1.5-.86a9.57,9.57,0,0,1,8.66,0l137.91,79.6,3.76-2.17Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,173.52a13.35,13.35,0,0,0-12.41,0l-1.49.86a7.71,7.71,0,0,0-3.89,5.54,7,7,0,0,0-.07,1v4.5l3.75,3.92V181a3.84,3.84,0,0,1,2.08-3.32l1.5-.86a9.57,9.57,0,0,1,8.66,0l137.91,79.6,3.76-2.17Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.34 256.37 398.1 254.2 398.1 274.9 394.34 272.67 394.34 256.37",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.34 256.37 398.1 254.2 398.1 274.9 394.34 272.67 394.34 256.37",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.16,366.34V272.92L261.63,193.44a9.31,9.31,0,0,0-9.29,0l-3.48,2v89.12l146,84.28A2.89,2.89,0,0,0,399.16,366.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.79,362.85l2.36-1.36a3,3,0,0,0,1.34-2.33v-96a3,3,0,0,0-1.34-2.34L263.66,188.92a3,3,0,0,0-2.69,0l-2.36,1.36a3,3,0,0,0-1.35,2.33v96a3,3,0,0,0,1.34,2.33L383.1,362.85A3,3,0,0,0,385.79,362.85Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.79,362.85l2.36-1.36a3,3,0,0,0,1.34-2.33v-96a3,3,0,0,0-1.34-2.34L263.66,188.92a3,3,0,0,0-2.69,0l-2.36,1.36a3,3,0,0,0-1.35,2.33v96a3,3,0,0,0,1.34,2.33L383.1,362.85A3,3,0,0,0,385.79,362.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,263.72,258.61,191.83c-.74-.43-1.35-.08-1.35.78v96a3,3,0,0,0,1.34,2.33L383.1,362.85c.74.43,1.34.08,1.34-.77v-96A3,3,0,0,0,383.1,263.72Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,263.72,258.61,191.83c-.74-.43-1.35-.08-1.35.78v96a3,3,0,0,0,1.34,2.33L383.1,362.85c.74.43,1.34.08,1.34-.77v-96A3,3,0,0,0,383.1,263.72Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,263.72,258.61,191.83c-.74-.43-1.35-.08-1.35.78v96a3,3,0,0,0,1.34,2.33L383.1,362.85c.74.43,1.34.08,1.34-.77v-96A3,3,0,0,0,383.1,263.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,191.83c10.22,6.27,20.51,12.39,30.83,18.49l31,18.12,31.21,17.82,15.67,8.8,15.75,8.66-15.38-9.31-15.45-9.18-31-18.12L290,209.29C279.59,203.41,269.14,197.55,258.61,191.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,264.72l5-2.91a2.59,2.59,0,0,1,.4,1.32v96a3,3,0,0,1-1.33,2.34l-2.36,1.36a3,3,0,0,1-2.43.12c.62.2,1.08-.16,1.08-.91v-96A2.6,2.6,0,0,0,384,264.72Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.44 277.01 389.49 274.1 389.49 299.2 384.44 302.08 384.44 277.01",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.44 277.01 389.49 274.1 389.49 299.2 384.44 302.08 384.44 277.01",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "257.26 203.56 384.44 277.01 384.44 302.08 257.26 228.63 257.26 203.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cards--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.59,331.88v16.41c0,1.23-.86,1.73-1.93,1.12l-17.23-9.82a4.26,4.26,0,0,1-1.93-3.34V319.84c0-1.23.87-1.73,1.93-1.11,4.7,2.71,12.53,7.1,17.23,9.81A4.26,4.26,0,0,1,376.59,331.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clippath: "url(#freepik--clipPath--inject-17)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "379.98 338.38 380.42 337.62 352.11 321.41 351.67 322.16 379.98 338.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.93,
    y: 331.74,
    width: 0.87,
    height: 8.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.29,
    y: 328.08,
    width: 0.87,
    height: 8.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.98 346.76 380.42 346 352.11 329.79 351.67 330.54 379.98 346.76",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.74,248.85a9.4,9.4,0,0,1-1.05-4.5c0-1.69.34-2.79,1-3.29s1.67-.37,3,.37a8.65,8.65,0,0,1,1.46,1.06,6.78,6.78,0,0,1,1.11,1.25.51.51,0,0,1,.11.3.37.37,0,0,1-.06.21l-.39.68c-.05.07-.1.1-.16.07a1,1,0,0,1-.18-.2,5.75,5.75,0,0,0-1.67-1.49q-1.14-.66-1.77-.15a2.9,2.9,0,0,0-.63,2.24,6.32,6.32,0,0,0,.66,3,4.57,4.57,0,0,0,1.79,1.9,2.75,2.75,0,0,0,1.75.48.37.37,0,0,1,.19,0,.53.53,0,0,1,.15.25l.43,1.24a.71.71,0,0,1,0,.2c0,.06,0,.11-.14.15-.57.21-1.46,0-2.66-.72A7.76,7.76,0,0,1,309.74,248.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52,253.73a1.15,1.15,0,0,1-.12-.55v-8.73q0-.33.12-.42c.07-.07.2-.05.38.06l2.79,1.61a5.29,5.29,0,0,1,2.81,4.89,3.09,3.09,0,0,1-.33,1.59,1.1,1.1,0,0,1-1,.54l1.16,4.06a1,1,0,0,1,0,.22c0,.18-.08.23-.23.14l-1.23-.71a.75.75,0,0,1-.23-.19.7.7,0,0,1-.13-.3l-1-3.83-1.32-.76v2.89c0,.21,0,.35-.11.41s-.2,0-.38-.07l-.83-.47A.92.92,0,0,1,316.52,253.73Zm2.91-3.44c.42.24.73.31.94.19s.32-.42.32-.93a2.65,2.65,0,0,0-.29-1.29,2.2,2.2,0,0,0-.86-.85l-1.32-.76v2.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,257.78a1.28,1.28,0,0,1-.11-.55v-8.74a.6.6,0,0,1,.11-.42c.08-.06.21,0,.38.06l4.59,2.65a.9.9,0,0,1,.37.35,1.3,1.3,0,0,1,.09.53v.55a.66.66,0,0,1-.09.43c-.07.06-.19,0-.37-.06l-3.26-1.89V253l2.28,1.32a.87.87,0,0,1,.36.35,1.14,1.14,0,0,1,.1.53v.52c0,.22,0,.37-.1.43s-.19,0-.36-.07l-2.28-1.31v2.34l3.25,1.88a.78.78,0,0,1,.36.36,1.16,1.16,0,0,1,.1.54v.53c0,.23,0,.37-.1.42s-.18,0-.36-.07l-4.58-2.64A1,1,0,0,1,323.52,257.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.87,261.44a1.15,1.15,0,0,1-.12-.55v-8.74a.55.55,0,0,1,.12-.42c.07-.06.2,0,.38.06l2.32,1.34a7.46,7.46,0,0,1,2.87,2.87,8.85,8.85,0,0,1,1,4.37q0,2.56-1,3.21c-.66.43-1.62.29-2.86-.43l-2.32-1.34A.85.85,0,0,1,329.87,261.44Zm2.79,0q1,.57,1.47.12a3.32,3.32,0,0,0,.48-2.22,6.53,6.53,0,0,0-.48-2.77,3.65,3.65,0,0,0-1.47-1.57l-1.09-.62v6.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.45,265.81a1.11,1.11,0,0,1-.12-.54v-8.74a.55.55,0,0,1,.12-.42c.07-.06.2,0,.38.06l.83.48a.87.87,0,0,1,.38.38,1.12,1.12,0,0,1,.11.55v8.74c0,.22,0,.36-.11.42s-.2,0-.38-.07l-.83-.48A.87.87,0,0,1,337.45,265.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,268.58a1.15,1.15,0,0,1-.11-.55v-7.59l-1.82-1a1,1,0,0,1-.36-.35,1.18,1.18,0,0,1-.1-.54V258c0-.22,0-.36.1-.42s.19,0,.36.06l5.46,3.15a.86.86,0,0,1,.37.36,1.22,1.22,0,0,1,.11.55v.54c0,.22,0,.36-.11.41s-.19,0-.37-.06L344,261.5v7.59c0,.22,0,.35-.12.41s-.2,0-.39-.07l-.82-.47A1,1,0,0,1,342.23,268.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,273.09a9.22,9.22,0,0,1-1.06-4.49c0-1.7.34-2.8,1-3.29s1.68-.38,3,.36a8.41,8.41,0,0,1,1.46,1.06,7.12,7.12,0,0,1,1.11,1.25.46.46,0,0,1,.11.3.35.35,0,0,1-.06.22l-.39.67c0,.08-.1.1-.15.07a.66.66,0,0,1-.19-.19,5.53,5.53,0,0,0-1.67-1.5c-.76-.43-1.35-.48-1.77-.14a2.89,2.89,0,0,0-.63,2.24,6.27,6.27,0,0,0,.66,3,4.62,4.62,0,0,0,1.8,1.91,2.71,2.71,0,0,0,1.74.48.28.28,0,0,1,.19,0,.48.48,0,0,1,.15.25l.44,1.23a.68.68,0,0,1,0,.21c0,.06,0,.1-.13.14-.58.22-1.47,0-2.67-.71A7.63,7.63,0,0,1,351.74,273.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,277.53a.76.76,0,0,1,0-.21l2.86-7.44a.43.43,0,0,1,.17-.25.32.32,0,0,1,.28.06l.8.47a.71.71,0,0,1,.27.24,1.74,1.74,0,0,1,.16.45l2.87,10.74a1.38,1.38,0,0,1,0,.25c0,.17-.07.22-.2.14l-1.34-.77a.62.62,0,0,1-.22-.2,1.1,1.1,0,0,1-.13-.32l-.51-2-2.68-1.55-.5,1.45c0,.1-.08.16-.13.17s-.12,0-.23-.06l-1.33-.77A.39.39,0,0,1,357.91,277.53Zm4.65-.8-.92-3.72-.92,2.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,282.54a1.15,1.15,0,0,1-.11-.55v-8.74a.56.56,0,0,1,.11-.42c.08-.06.21,0,.38.06l2.8,1.62a5.29,5.29,0,0,1,2.81,4.89,2.94,2.94,0,0,1-.34,1.58,1.1,1.1,0,0,1-1,.55l1.16,4.06a.89.89,0,0,1,0,.22c0,.18-.07.22-.23.13l-1.22-.71a.79.79,0,0,1-.24-.18,1,1,0,0,1-.13-.31l-1-3.82-1.31-.76V283a.57.57,0,0,1-.11.42c-.08.06-.2,0-.39-.07l-.83-.48A1,1,0,0,1,366.41,282.54Zm2.91-3.44c.42.24.74.3.95.19s.31-.43.31-.94a2.61,2.61,0,0,0-.28-1.28,2.32,2.32,0,0,0-.87-.86l-1.31-.75v2.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.42,286.58a1.13,1.13,0,0,1-.12-.54V277.3q0-.33.12-.42c.08-.06.2,0,.38.06l2.32,1.34a7.37,7.37,0,0,1,2.87,2.86,8.88,8.88,0,0,1,1,4.37c0,1.71-.33,2.78-1,3.22s-1.62.29-2.86-.43L373.8,287A.93.93,0,0,1,373.42,286.58Zm2.79,0q1,.57,1.47.12c.32-.29.48-1,.48-2.21a6.5,6.5,0,0,0-.48-2.77,3.6,3.6,0,0,0-1.47-1.57l-1.08-.63v6.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.74,248.85a9.4,9.4,0,0,1-1.05-4.5c0-1.69.34-2.79,1-3.29s1.67-.37,3,.37a8.65,8.65,0,0,1,1.46,1.06,6.78,6.78,0,0,1,1.11,1.25.51.51,0,0,1,.11.3.37.37,0,0,1-.06.21l-.39.68c-.05.07-.1.1-.16.07a1,1,0,0,1-.18-.2,5.75,5.75,0,0,0-1.67-1.49q-1.14-.66-1.77-.15a2.9,2.9,0,0,0-.63,2.24,6.32,6.32,0,0,0,.66,3,4.57,4.57,0,0,0,1.79,1.9,2.75,2.75,0,0,0,1.75.48.37.37,0,0,1,.19,0,.53.53,0,0,1,.15.25l.43,1.24a.71.71,0,0,1,0,.2c0,.06,0,.11-.14.15-.57.21-1.46,0-2.66-.72A7.76,7.76,0,0,1,309.74,248.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52,253.73a1.15,1.15,0,0,1-.12-.55v-8.73q0-.33.12-.42c.07-.07.2-.05.38.06l2.79,1.61a5.29,5.29,0,0,1,2.81,4.89,3.09,3.09,0,0,1-.33,1.59,1.1,1.1,0,0,1-1,.54l1.16,4.06a1,1,0,0,1,0,.22c0,.18-.08.23-.23.14l-1.23-.71a.75.75,0,0,1-.23-.19.7.7,0,0,1-.13-.3l-1-3.83-1.32-.76v2.89c0,.21,0,.35-.11.41s-.2,0-.38-.07l-.83-.47A.92.92,0,0,1,316.52,253.73Zm2.91-3.44c.42.24.73.31.94.19s.32-.42.32-.93a2.65,2.65,0,0,0-.29-1.29,2.2,2.2,0,0,0-.86-.85l-1.32-.76v2.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,257.78a1.28,1.28,0,0,1-.11-.55v-8.74a.6.6,0,0,1,.11-.42c.08-.06.21,0,.38.06l4.59,2.65a.9.9,0,0,1,.37.35,1.3,1.3,0,0,1,.09.53v.55a.66.66,0,0,1-.09.43c-.07.06-.19,0-.37-.06l-3.26-1.89V253l2.28,1.32a.87.87,0,0,1,.36.35,1.14,1.14,0,0,1,.1.53v.52c0,.22,0,.37-.1.43s-.19,0-.36-.07l-2.28-1.31v2.34l3.25,1.88a.78.78,0,0,1,.36.36,1.16,1.16,0,0,1,.1.54v.53c0,.23,0,.37-.1.42s-.18,0-.36-.07l-4.58-2.64A1,1,0,0,1,323.52,257.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.87,261.44a1.15,1.15,0,0,1-.12-.55v-8.74a.55.55,0,0,1,.12-.42c.07-.06.2,0,.38.06l2.32,1.34a7.46,7.46,0,0,1,2.87,2.87,8.85,8.85,0,0,1,1,4.37q0,2.56-1,3.21c-.66.43-1.62.29-2.86-.43l-2.32-1.34A.85.85,0,0,1,329.87,261.44Zm2.79,0q1,.57,1.47.12a3.32,3.32,0,0,0,.48-2.22,6.53,6.53,0,0,0-.48-2.77,3.65,3.65,0,0,0-1.47-1.57l-1.09-.62v6.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.45,265.81a1.11,1.11,0,0,1-.12-.54v-8.74a.55.55,0,0,1,.12-.42c.07-.06.2,0,.38.06l.83.48a.87.87,0,0,1,.38.38,1.12,1.12,0,0,1,.11.55v8.74c0,.22,0,.36-.11.42s-.2,0-.38-.07l-.83-.48A.87.87,0,0,1,337.45,265.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,268.58a1.15,1.15,0,0,1-.11-.55v-7.59l-1.82-1a1,1,0,0,1-.36-.35,1.18,1.18,0,0,1-.1-.54V258c0-.22,0-.36.1-.42s.19,0,.36.06l5.46,3.15a.86.86,0,0,1,.37.36,1.22,1.22,0,0,1,.11.55v.54c0,.22,0,.36-.11.41s-.19,0-.37-.06L344,261.5v7.59c0,.22,0,.35-.12.41s-.2,0-.39-.07l-.82-.47A1,1,0,0,1,342.23,268.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,273.09a9.22,9.22,0,0,1-1.06-4.49c0-1.7.34-2.8,1-3.29s1.68-.38,3,.36a8.41,8.41,0,0,1,1.46,1.06,7.12,7.12,0,0,1,1.11,1.25.46.46,0,0,1,.11.3.35.35,0,0,1-.06.22l-.39.67c0,.08-.1.1-.15.07a.66.66,0,0,1-.19-.19,5.53,5.53,0,0,0-1.67-1.5c-.76-.43-1.35-.48-1.77-.14a2.89,2.89,0,0,0-.63,2.24,6.27,6.27,0,0,0,.66,3,4.62,4.62,0,0,0,1.8,1.91,2.71,2.71,0,0,0,1.74.48.28.28,0,0,1,.19,0,.48.48,0,0,1,.15.25l.44,1.23a.68.68,0,0,1,0,.21c0,.06,0,.1-.13.14-.58.22-1.47,0-2.67-.71A7.63,7.63,0,0,1,351.74,273.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,277.53a.76.76,0,0,1,0-.21l2.86-7.44a.43.43,0,0,1,.17-.25.32.32,0,0,1,.28.06l.8.47a.71.71,0,0,1,.27.24,1.74,1.74,0,0,1,.16.45l2.87,10.74a1.38,1.38,0,0,1,0,.25c0,.17-.07.22-.2.14l-1.34-.77a.62.62,0,0,1-.22-.2,1.1,1.1,0,0,1-.13-.32l-.51-2-2.68-1.55-.5,1.45c0,.1-.08.16-.13.17s-.12,0-.23-.06l-1.33-.77A.39.39,0,0,1,357.91,277.53Zm4.65-.8-.92-3.72-.92,2.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,282.54a1.15,1.15,0,0,1-.11-.55v-8.74a.56.56,0,0,1,.11-.42c.08-.06.21,0,.38.06l2.8,1.62a5.29,5.29,0,0,1,2.81,4.89,2.94,2.94,0,0,1-.34,1.58,1.1,1.1,0,0,1-1,.55l1.16,4.06a.89.89,0,0,1,0,.22c0,.18-.07.22-.23.13l-1.22-.71a.79.79,0,0,1-.24-.18,1,1,0,0,1-.13-.31l-1-3.82-1.31-.76V283a.57.57,0,0,1-.11.42c-.08.06-.2,0-.39-.07l-.83-.48A1,1,0,0,1,366.41,282.54Zm2.91-3.44c.42.24.74.3.95.19s.31-.43.31-.94a2.61,2.61,0,0,0-.28-1.28,2.32,2.32,0,0,0-.87-.86l-1.31-.75v2.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.42,286.58a1.13,1.13,0,0,1-.12-.54V277.3q0-.33.12-.42c.08-.06.2,0,.38.06l2.32,1.34a7.37,7.37,0,0,1,2.87,2.86,8.88,8.88,0,0,1,1,4.37c0,1.71-.33,2.78-1,3.22s-1.62.29-2.86-.43L373.8,287A.93.93,0,0,1,373.42,286.58Zm2.79,0q1,.57,1.47.12c.32-.29.48-1,.48-2.21a6.5,6.5,0,0,0-.48-2.77,3.6,3.6,0,0,0-1.47-1.57l-1.08-.63v6.44Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,269.19l4.91,2.84a2.53,2.53,0,0,1,1.16,2v1.5c0,.74-.52,1-1.16.67l-4.91-2.84a2.55,2.55,0,0,1-1.16-2v-1.5C274.62,269.12,275.14,268.82,275.78,269.19Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,262.93l4.91,2.84a2.55,2.55,0,0,1,1.16,2v1.5c0,.74-.52,1-1.16.67l-4.91-2.84a2.55,2.55,0,0,1-1.16-2v-1.5C263.78,262.86,264.3,262.56,264.94,262.93Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,309.19,265.8,273.86c-1.06-.62-1.92-.12-1.92,1.11v1.81a4.27,4.27,0,0,0,1.92,3.34L327,315.44c1.07.62,1.93.12,1.93-1.11v-1.81A4.22,4.22,0,0,0,327,309.19Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,269.19l4.91,2.84a2.53,2.53,0,0,1,1.16,2v1.5c0,.74-.52,1-1.16.67l-4.91-2.84a2.55,2.55,0,0,1-1.16-2v-1.5C274.62,269.12,275.14,268.82,275.78,269.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,262.93l4.91,2.84a2.55,2.55,0,0,1,1.16,2v1.5c0,.74-.52,1-1.16.67l-4.91-2.84a2.55,2.55,0,0,1-1.16-2v-1.5C263.78,262.86,264.3,262.56,264.94,262.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,309.19,265.8,273.86c-1.06-.62-1.92-.12-1.92,1.11v1.81a4.27,4.27,0,0,0,1.92,3.34L327,315.44c1.07.62,1.93.12,1.93-1.11v-1.81A4.22,4.22,0,0,0,327,309.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,245.89l.23.13a3,3,0,0,1,1.25,2.4v4.82c0,.92-.56,1.36-1.27,1l-.19-.1a2.9,2.9,0,0,1-1.27-2.36v-4.92C263.78,245.92,264.34,245.49,265,245.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,249.65l.22.13a3,3,0,0,1,1.26,2.39V257c0,.93-.57,1.37-1.27,1l-.2-.11a2.89,2.89,0,0,1-1.27-2.36V250.6C270.24,249.67,270.8,249.25,271.5,249.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,253.4l.23.13a3,3,0,0,1,1.25,2.4v4.82c0,.92-.57,1.36-1.27,1l-.19-.1a2.88,2.88,0,0,1-1.27-2.36v-4.92C276.71,253.43,277.27,253,278,253.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,257.16l.23.13a3,3,0,0,1,1.25,2.39v4.82c0,.93-.57,1.37-1.27,1l-.19-.11a2.9,2.9,0,0,1-1.27-2.36V258.1C283.17,257.18,283.73,256.76,284.42,257.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.26,263.34l.23.13a3,3,0,0,1,1.25,2.4v4.82c0,.92-.57,1.36-1.27,1l-.19-.1a2.9,2.9,0,0,1-1.27-2.36v-4.92C294,263.37,294.57,262.94,295.26,263.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.72,267.1l.23.13a3,3,0,0,1,1.25,2.39v4.82c0,.92-.57,1.36-1.27,1l-.2-.1a2.9,2.9,0,0,1-1.27-2.36V268C300.47,267.12,301,266.7,301.72,267.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.19,270.85l.22.13a3,3,0,0,1,1.26,2.4v4.82c0,.92-.57,1.36-1.27,1l-.2-.11a2.89,2.89,0,0,1-1.27-2.35V271.8C306.93,270.88,307.49,270.45,308.19,270.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.65,274.61l.23.13a3,3,0,0,1,1.25,2.39V282c0,.92-.57,1.36-1.27,1l-.19-.1a2.9,2.9,0,0,1-1.27-2.36v-4.92C313.4,274.63,314,274.21,314.65,274.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.49,280.79l.23.13a3,3,0,0,1,1.25,2.4v4.82c0,.92-.57,1.36-1.27,1l-.19-.11a2.89,2.89,0,0,1-1.27-2.35v-4.92C324.24,280.81,324.8,280.39,325.49,280.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,284.55l.23.13a3,3,0,0,1,1.25,2.39v4.82c0,.92-.56,1.36-1.27,1l-.19-.1a2.9,2.9,0,0,1-1.27-2.36v-4.92C330.7,284.57,331.26,284.15,332,284.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.42,288.3l.22.13a3,3,0,0,1,1.26,2.4v4.81c0,.93-.57,1.37-1.27,1l-.2-.11a2.89,2.89,0,0,1-1.27-2.36v-4.91C337.16,288.32,337.72,287.9,338.42,288.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.88,292.05l.23.14a3,3,0,0,1,1.25,2.39v4.82c0,.92-.57,1.36-1.27,1l-.19-.1a2.88,2.88,0,0,1-1.27-2.36V293C343.62,292.08,344.19,291.65,344.88,292.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.72,298.24l.23.13a3,3,0,0,1,1.25,2.4v4.81c0,.93-.57,1.37-1.27,1l-.19-.11a2.86,2.86,0,0,1-1.27-2.36v-4.91C354.47,298.26,355,297.84,355.72,298.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,302l.23.14a3,3,0,0,1,1.25,2.39v4.82c0,.92-.57,1.36-1.27,1l-.19-.1a2.9,2.9,0,0,1-1.27-2.36v-4.92C360.93,302,361.49,301.59,362.18,302Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,305.75l.23.13a3,3,0,0,1,1.25,2.39v4.82c0,.93-.56,1.37-1.27,1l-.19-.11a2.89,2.89,0,0,1-1.27-2.36V306.7C367.39,305.77,368,305.35,368.64,305.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.11,309.5l.22.13a3,3,0,0,1,1.26,2.4v4.82c0,.92-.57,1.36-1.27,1l-.2-.1a2.9,2.9,0,0,1-1.27-2.36v-4.92C373.85,309.53,374.41,309.1,375.11,309.5Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M392.43,367.17c0,2.75-1.95,3.87-4.33,2.5L270.84,302a9.6,9.6,0,0,1-4.33-7.5V229.11l125.92,72.7Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.22,321.1l98.06,102.69c1,1.07,2,1.39,2.58,1s.87-1.13.87-2.4V301.13a12.81,12.81,0,0,0-1-4.44,13,13,0,0,0-2.5-4.17L235.22,189.77A15.66,15.66,0,0,1,230.73,179V310.32A15.66,15.66,0,0,0,235.22,321.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.73,204.54a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,.32-.46.49.49,0,0,1,.54.11l1,1.09a.5.5,0,0,1,0,.71.49.49,0,0,1-.7,0l-.18-.18V204A.5.5,0,0,1,237.73,204.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,404a.51.51,0,0,1-.5-.5v-2.95a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,404Zm0-7.87a.5.5,0,0,1-.5-.5V392.7a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,396.15Zm0-7.87a.5.5,0,0,1-.5-.5v-2.95a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,388.28Zm0-7.87a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,329.73,380.41Zm0-7.87a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,329.73,372.54Zm0-7.87a.5.5,0,0,1-.5-.5v-2.95a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,364.67Zm0-7.87a.5.5,0,0,1-.5-.5v-2.95a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,356.8Zm0-7.86a.51.51,0,0,1-.5-.5v-3a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,329.73,348.94Zm0-7.87a.51.51,0,0,1-.5-.5v-2.95a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,341.07Zm0-7.87a.51.51,0,0,1-.5-.5v-2.95a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,333.2Zm0-7.87a.51.51,0,0,1-.5-.5v-2.95a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,325.33Zm0-7.87a.5.5,0,0,1-.5-.5V314a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V317A.5.5,0,0,1,329.73,317.46Zm0-7.87a.5.5,0,0,1-.5-.5v-2.95a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.95A.5.5,0,0,1,329.73,309.59Zm0-7.91a.47.47,0,0,1-.5-.46,5.59,5.59,0,0,0-.44-1.81c-.12-.29-.23-.55-.34-.77a.49.49,0,0,1,.22-.67.49.49,0,0,1,.67.22c.12.25.25.53.38.86a6.6,6.6,0,0,1,.51,2.08A.54.54,0,0,1,329.73,301.68Zm-4-6.47a.52.52,0,0,1-.36-.16l-2-2.13a.5.5,0,1,1,.73-.69l2,2.13a.5.5,0,0,1,0,.71A.52.52,0,0,1,325.69,295.21Zm-5.43-5.7a.51.51,0,0,1-.36-.15l-2-2.14a.5.5,0,0,1,.72-.69l2,2.14a.5.5,0,0,1-.36.84Zm-5.43-5.69a.49.49,0,0,1-.36-.15l-2-2.14a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l2,2.14a.5.5,0,0,1-.36.84Zm-5.44-5.69A.48.48,0,0,1,309,278l-2-2.13a.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0l2,2.13a.5.5,0,0,1,0,.71A.52.52,0,0,1,309.39,278.13ZM304,272.44a.52.52,0,0,1-.36-.16l-2-2.13a.5.5,0,1,1,.73-.69l2,2.13a.5.5,0,0,1,0,.71A.52.52,0,0,1,304,272.44Zm-5.43-5.7a.51.51,0,0,1-.36-.15l-2-2.14a.5.5,0,0,1,.72-.69l2,2.14a.49.49,0,0,1,0,.7A.45.45,0,0,1,298.53,266.74Zm-5.43-5.69a.48.48,0,0,1-.36-.15l-2-2.14a.5.5,0,1,1,.72-.69l2,2.14a.49.49,0,0,1,0,.7A.51.51,0,0,1,293.1,261.05Zm-5.44-5.69a.48.48,0,0,1-.36-.16l-2-2.13a.5.5,0,1,1,.73-.69l2,2.13a.5.5,0,0,1,0,.71A.52.52,0,0,1,287.66,255.36Zm-5.43-5.7a.51.51,0,0,1-.36-.15l-2-2.13a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l2,2.13a.5.5,0,0,1,0,.71A.53.53,0,0,1,282.23,249.66ZM276.8,244a.49.49,0,0,1-.36-.15l-2-2.14a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l2,2.14a.49.49,0,0,1,0,.7A.45.45,0,0,1,276.8,244Zm-5.44-5.69a.51.51,0,0,1-.36-.15L269,236a.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0l2,2.14a.49.49,0,0,1,0,.7A.52.52,0,0,1,271.36,238.28Zm-5.43-5.69a.48.48,0,0,1-.36-.16l-2-2.13a.5.5,0,0,1,.73-.69l2,2.13a.5.5,0,0,1,0,.71A.52.52,0,0,1,265.93,232.59Zm-5.43-5.69a.52.52,0,0,1-.36-.16l-2-2.13a.5.5,0,0,1,.72-.7l2,2.14a.5.5,0,0,1,0,.71A.49.49,0,0,1,260.5,226.9Zm-5.43-5.7a.51.51,0,0,1-.37-.15l-2-2.14a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l2,2.14a.49.49,0,0,1,0,.7A.47.47,0,0,1,255.07,221.2Zm-5.44-5.69a.48.48,0,0,1-.36-.16l-2-2.13a.5.5,0,0,1,.73-.69l2,2.13a.5.5,0,0,1,0,.71A.52.52,0,0,1,249.63,215.51Zm-5.43-5.69a.48.48,0,0,1-.36-.16l-2-2.13a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l2,2.13a.5.5,0,0,1,0,.71A.49.49,0,0,1,244.2,209.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,410.44a.51.51,0,0,1-.36-.15l-1-1.09a.5.5,0,1,1,.73-.69l.17.18v-.25a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.5a.48.48,0,0,1-.31.46A.43.43,0,0,1,329.73,410.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.19,405.68a.48.48,0,0,1-.36-.15l-2.11-2.21a.51.51,0,0,1,0-.71.5.5,0,0,1,.71,0l2.11,2.21a.49.49,0,0,1,0,.7A.51.51,0,0,1,325.19,405.68Zm-5.62-5.88a.48.48,0,0,1-.36-.16l-2.11-2.2a.5.5,0,0,1,.73-.69l2.1,2.2a.5.5,0,0,1,0,.71A.54.54,0,0,1,319.57,399.8ZM314,393.92a.48.48,0,0,1-.36-.16l-2.1-2.2a.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0l2.1,2.2a.5.5,0,0,1,0,.71A.52.52,0,0,1,314,393.92ZM308.34,388a.5.5,0,0,1-.36-.16l-2.11-2.21a.5.5,0,0,1,.72-.69l2.11,2.21a.5.5,0,0,1,0,.71A.51.51,0,0,1,308.34,388Zm-5.62-5.89a.51.51,0,0,1-.36-.15l-2.11-2.21a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l2.1,2.21a.5.5,0,0,1,0,.71A.53.53,0,0,1,302.72,382.15Zm-5.62-5.88a.51.51,0,0,1-.36-.15l-2.1-2.21a.5.5,0,1,1,.72-.69l2.11,2.21a.49.49,0,0,1,0,.7A.47.47,0,0,1,297.1,376.27Zm-5.61-5.88a.49.49,0,0,1-.36-.15L289,368a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l2.11,2.2a.5.5,0,0,1,0,.71A.49.49,0,0,1,291.49,370.39Zm-5.62-5.88a.48.48,0,0,1-.36-.16l-2.11-2.2a.5.5,0,1,1,.73-.69l2.1,2.2a.5.5,0,0,1,0,.71A.52.52,0,0,1,285.87,364.51Zm-5.62-5.88a.48.48,0,0,1-.36-.16l-2.1-2.2a.5.5,0,1,1,.72-.69l2.11,2.2a.5.5,0,0,1,0,.71A.52.52,0,0,1,280.25,358.63Zm-5.61-5.88a.52.52,0,0,1-.36-.16l-2.11-2.21a.5.5,0,0,1,.72-.69L275,351.9a.5.5,0,0,1,0,.71A.49.49,0,0,1,274.64,352.75ZM269,346.86a.51.51,0,0,1-.36-.15l-2.11-2.21a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l2.1,2.21a.49.49,0,0,1-.36.84ZM263.41,341a.51.51,0,0,1-.37-.15l-2.1-2.21a.5.5,0,1,1,.72-.69l2.11,2.21a.49.49,0,0,1,0,.7A.47.47,0,0,1,263.41,341Zm-5.62-5.88a.51.51,0,0,1-.36-.15l-2.11-2.21a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l2.11,2.2a.5.5,0,0,1,0,.71A.49.49,0,0,1,257.79,335.1Zm-5.62-5.88a.48.48,0,0,1-.36-.16l-2.11-2.2a.5.5,0,1,1,.73-.69l2.1,2.2a.5.5,0,0,1,0,.71A.52.52,0,0,1,252.17,329.22Zm-5.61-5.88a.49.49,0,0,1-.37-.16l-2.1-2.2a.5.5,0,1,1,.72-.69l2.11,2.2a.5.5,0,0,1,0,.71A.51.51,0,0,1,246.56,323.34Zm-5.62-5.88a.52.52,0,0,1-.36-.16l-.66-.69a9.62,9.62,0,0,1-1.34-1.74.48.48,0,0,1,.16-.68.49.49,0,0,1,.69.16,9.47,9.47,0,0,0,1.22,1.57l.65.69a.5.5,0,0,1,0,.71A.49.49,0,0,1,240.94,317.46Zm-3.21-7.19a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,237.73,310.27Zm0-8.13a.51.51,0,0,1-.5-.5v-3.05a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,302.14Zm0-8.14a.5.5,0,0,1-.5-.5v-3.05a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,294Zm0-8.13a.5.5,0,0,1-.5-.5v-3.05a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,285.87Zm0-8.13a.5.5,0,0,1-.5-.5v-3.05a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,277.74Zm0-8.13a.51.51,0,0,1-.5-.5v-3.05a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,269.61Zm0-8.14a.5.5,0,0,1-.5-.5v-3.05a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V261A.5.5,0,0,1,237.73,261.47Zm0-8.13a.5.5,0,0,1-.5-.5v-3.05a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,253.34Zm0-8.13a.5.5,0,0,1-.5-.5v-3.05a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,245.21Zm0-8.13a.51.51,0,0,1-.5-.5v-3.05a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,237.08Zm0-8.14a.5.5,0,0,1-.5-.5v-3.05a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,228.94Zm0-8.13a.5.5,0,0,1-.5-.5v-3.05a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,220.81Zm0-8.13a.5.5,0,0,1-.5-.5v-3.05a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.05A.5.5,0,0,1,237.73,212.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.57,292.76l-6.79,3.93a12.81,12.81,0,0,1,1,4.44V422.41c0,1.27-.33,2.08-.87,2.4l6.68-3.86c.55-.31.88-1.13.88-2.4V297.27A12.37,12.37,0,0,0,342.57,292.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,343.09a16.16,16.16,0,0,0-3.64-9.74c-2-2.1-3.64-1.16-3.64,2.11a16.11,16.11,0,0,0,3.64,9.73C317.18,347.3,318.81,346.36,318.81,343.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.87 298.95 428.72 308.68 411.87 318.41 411.87 298.95",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.66,311l3.79-2.19a2.64,2.64,0,0,0,0-5l-16.58-9.58V299l11.57,6.68a.82.82,0,0,1,0,1.41l-2.84,1.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.82,320.1c-4.78,2.76-8.66,9.2-8.66,14.38,0,2.5.91,4.25,2.38,5.08s4.11,2.37,4.11,2.37l25.74-16.68a3,3,0,0,0,1.79-2.49V304a3,3,0,0,1-1.79,2.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.89,322.44c-4.79,2.76-8.66,9.2-8.66,14.38s3.87,7.14,8.66,4.38l23.56-13.61a3.06,3.06,0,0,0,1.8-2.49V306.34a3,3,0,0,1-1.8,2.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.35,325.25c2.75-1.59,5-.3,5,2.87a11.07,11.07,0,0,1-5,8.63c-2.75,1.59-5,.3-5-2.88A11,11,0,0,1,406.35,325.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,288.66,240.65,184.59a8.8,8.8,0,0,1-2.05-3.34l-3.38,8.52,98.06,102.75a13.28,13.28,0,0,1,2.5,4.17l6.79-3.93A12.45,12.45,0,0,0,340,288.66Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.12,165.29l5.25-9.88-4.22-12.2v-7.47l12.93,7.47v7.47l-5.56,9.63a.78.78,0,0,1-.38.34h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.82,73.94a8.59,8.59,0,0,1,3.88-6.72l3.16-1.82a8.54,8.54,0,0,1,7.75,0l61.17,35.15a8.59,8.59,0,0,1,3.88,6.72v53.28a8.58,8.58,0,0,1-3.88,6.72l-3.16,1.82a8.54,8.54,0,0,1-7.75,0L344,155.38,338.41,165a.83.83,0,0,1-1.5-.15l-5.86-16.93-24.35-14a8.56,8.56,0,0,1-3.88-6.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.66,160.55a8.58,8.58,0,0,1-3.88,6.72l-3.16,1.82a8.66,8.66,0,0,1-7.09.32c1.82.69,3.21-.34,3.21-2.56V113.57a7.9,7.9,0,0,0-1.13-3.82l10.91-6.3a7.92,7.92,0,0,1,1.14,3.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,72.84c.45-1.65,1.95-2.17,3.74-1.14l61.18,35.16a7.63,7.63,0,0,1,2.73,2.89l10.91-6.29a7.81,7.81,0,0,0-2.73-2.9L317.62,65.4a8.62,8.62,0,0,0-7.76,0l-3.17,1.83A8.57,8.57,0,0,0,303,72.84Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361,115.88,316.28,90.06c-.88-.51-1.6-.09-1.6.92v30.9a3.54,3.54,0,0,0,1.6,2.76L361,150.46c.88.51,1.6.1,1.6-.92V118.65A3.54,3.54,0,0,0,361,115.88Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33,145.1a.79.79,0,0,1-.37-.1l-36.48-21.07a.73.73,0,0,1-.37-.64,3.7,3.7,0,0,0-1.85-3.19.75.75,0,0,1-.37-.64V98.08a.76.76,0,0,1,.37-.64.75.75,0,0,1,.74,0,1.48,1.48,0,0,0,2.21-1.28.72.72,0,0,1,.37-.63.7.7,0,0,1,.74,0l36.48,21.06a.74.74,0,0,1,.37.64,3.69,3.69,0,0,0,1.85,3.19.75.75,0,0,1,.36.64v21.38a.74.74,0,0,1-1.1.64,1.47,1.47,0,0,0-2.21,1.28.74.74,0,0,1-.37.64A.82.82,0,0,1,356.33,145.1Zm-35.77-22.24,35.26,20.35a2.87,2.87,0,0,1,1.25-1.4,2.94,2.94,0,0,1,1.84-.38v-20a5.17,5.17,0,0,1-2.19-3.79L321.46,97.31a3,3,0,0,1-3.09,1.78v20A5.19,5.19,0,0,1,320.56,122.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.59,129.52a6.72,6.72,0,0,1-3.32-1,15.43,15.43,0,0,1-7-12.07c0-2.31.82-4,2.3-4.91s3.41-.69,5.41.46a15.45,15.45,0,0,1,7,12.07c0,2.31-.82,4.06-2.31,4.91A4.11,4.11,0,0,1,341.59,129.52Zm-5.89-17.05a2.67,2.67,0,0,0-1.36.35c-1,.58-1.56,1.87-1.56,3.63A13.77,13.77,0,0,0,339,127.24c1.52.88,2.92,1,3.93.47s1.56-1.88,1.56-3.64a13.77,13.77,0,0,0-6.23-10.79A5.31,5.31,0,0,0,335.7,112.47Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.26,50.54c-3.48-2-8.06-2-13.23.52C57.82,56.94,47,74.36,45.79,90c-.67,8.84,1.91,15.2,6.49,18,1.17.71,5.72,3.29,6.8,3.94,3.5,2.07,8.15,2.09,13.4-.43,12.21-5.88,23.07-23.3,24.24-38.9.68-9-2-15.39-6.7-18.11C88.9,53.8,84.41,51.19,83.26,50.54Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,50.54c-3.48-2-8.06-2-13.23.52C57.82,56.94,47,74.36,45.79,90c-.67,8.84,1.91,15.2,6.49,18,1.17.71,5.72,3.29,6.8,3.94,3.5,2.07,8.15,2.09,13.4-.43,12.21-5.88,23.07-23.3,24.24-38.9.68-9-2-15.39-6.7-18.11C88.9,53.8,84.41,51.19,83.26,50.54Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,82.1,58.11,60.86c-6.68,8-11.56,18.94-12.32,29.1-.67,8.84,1.91,15.2,6.49,18,1.17.71,5.72,3.29,6.8,3.94,3.5,2.07,8.15,2.09,13.4-.43C82.23,106.76,91.11,94.71,94.9,82.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.82,79.75a45.49,45.49,0,0,0-2,10.21c-.67,8.84,1.91,15.2,6.49,18,1.17.71,5.72,3.29,6.8,3.94,3.5,2.07,8.15,2.09,13.4-.43a37.6,37.6,0,0,0,12.36-10.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,54.93c-12.22,5.88-23.07,23.3-24.25,38.91s7.77,23.49,20,17.62,23.07-23.3,24.25-38.9S89,49.06,76.74,54.93Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74,54.93c-12.22,5.88-23.07,23.3-24.25,38.91s7.77,23.49,20,17.62,23.07-23.3,24.25-38.9S89,49.06,76.74,54.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,76.12A37.25,37.25,0,0,1,83.35,90.9c-3,4.77-6.63,8.52-10.3,10.55-3.89,2.15-7.38,2.15-9.82,0s-3.46-6.12-2.85-11.17a37,37,0,0,1,5.48-14.78c3-4.77,6.63-8.51,10.31-10.55,3.88-2.15,7.37-2.15,9.81,0S89.44,71.07,88.84,76.12Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,76.12A37.25,37.25,0,0,1,83.35,90.9c-3,4.77-6.63,8.52-10.3,10.55-3.89,2.15-7.38,2.15-9.82,0s-3.46-6.12-2.85-11.17a37,37,0,0,1,5.48-14.78c3-4.77,6.63-8.51,10.31-10.55,3.88-2.15,7.37-2.15,9.81,0S89.44,71.07,88.84,76.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,56.88c-3.38-3-8.26-3.16-13.72-.54-5.7,2.75-11.3,8.2-15.75,15.34a50.81,50.81,0,0,0-7.76,22.37c-.52,7,1,12.47,4.43,15.45s8.25,3.17,13.72.54c5.7-2.74,11.3-8.18,15.75-15.32a50.71,50.71,0,0,0,7.75-22.38C96,65.35,94.39,59.87,91,56.88ZM86,65c2.44,2.15,3.46,6.12,2.86,11.17A37.25,37.25,0,0,1,83.35,90.9c-3,4.77-6.63,8.52-10.3,10.55-3.89,2.15-7.38,2.15-9.82,0s-3.46-6.12-2.85-11.17a37,37,0,0,1,5.48-14.78c3-4.77,6.63-8.51,10.31-10.55C80.05,62.79,83.54,62.79,86,65Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.65,66c7.29-4,12.3.37,11.17,9.85s-7.95,20.43-15.25,24.47S60.27,100,61.4,90.5,69.35,70.07,76.65,66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.65,66c7.29-4,12.3.37,11.17,9.85s-7.95,20.43-15.25,24.47S60.27,100,61.4,90.5,69.35,70.07,76.65,66Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.65,66c7.29-4,12.3.37,11.17,9.85s-7.95,20.43-15.25,24.47S60.27,100,61.4,90.5,69.35,70.07,76.65,66Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73,74c-1.13,9.48-8,20.43-15.25,24.47-3,1.67-5.64,1.89-7.61.91-1.36-2-1.94-5-1.47-8.92C62.52,81,69.35,70.07,76.65,66c3-1.67,5.64-1.89,7.6-.91C85.61,67.08,86.19,70.12,85.73,74Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73,74c-1.13,9.48-8,20.43-15.25,24.47-3,1.67-5.64,1.89-7.61.91-1.36-2-1.94-5-1.47-8.92C62.52,81,69.35,70.07,76.65,66c3-1.67,5.64-1.89,7.6-.91C85.61,67.08,86.19,70.12,85.73,74Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.65,79.51c-.88-.55-2.16-.34-3.48,0L74,79.93a3.85,3.85,0,0,1,1.53-1.52c1.75-1.06,2.49-.16,2.67.72l4.23-3.79A4.08,4.08,0,0,0,82,74.17a2.61,2.61,0,0,0-.77-.78c-.2-.12-3.08-1.69-3.36-1.77a3.42,3.42,0,0,0-.79-.11l0-.5L74.29,69.5l-3.32,2,0,.6.07,2.06s-1.64.69-3.41,3.8c-.08.13-.14.25-.21.37a8.4,8.4,0,0,0-1,4.27v0a3,3,0,0,0,1.15,2.63c.06,0,2.31,1.23,2.68,1.47l.26.14.2.08h0l.23.06.21,0h.08l.17,0A5.94,5.94,0,0,0,72.89,87c.25,0,.51-.12.77-.19l1.11-.33.33-.11a4.14,4.14,0,0,1-1.53,1.45,4.29,4.29,0,0,1-1,.48L71,87.39,67,91a3,3,0,0,0,1.12,1.55c.49.33,2.43,1.33,2.86,1.58a2.52,2.52,0,0,0,1.17.36l0,.59,2.73,1.5,3.36-2-.11-2.65a12.27,12.27,0,0,0,3.3-3.68l0,0a8.45,8.45,0,0,0,1.11-4.46c-.06-1.49-.49-2.32-1.13-2.73S79,79.75,78.65,79.51Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.65,79.51c-.88-.55-2.16-.34-3.48,0L74,79.93a3.85,3.85,0,0,1,1.53-1.52c1.75-1.06,2.49-.16,2.67.72l4.23-3.79A4.08,4.08,0,0,0,82,74.17a2.61,2.61,0,0,0-.77-.78c-.2-.12-3.08-1.69-3.36-1.77a3.42,3.42,0,0,0-.79-.11l0-.5L74.29,69.5l-3.32,2,0,.6.07,2.06s-1.64.69-3.41,3.8c-.08.13-.14.25-.21.37a8.4,8.4,0,0,0-1,4.27v0a3,3,0,0,0,1.15,2.63c.06,0,2.31,1.23,2.68,1.47l.26.14.2.08h0l.23.06.21,0h.08l.17,0A5.94,5.94,0,0,0,72.89,87c.25,0,.51-.12.77-.19l1.11-.33.33-.11a4.14,4.14,0,0,1-1.53,1.45,4.29,4.29,0,0,1-1,.48L71,87.39,67,91a3,3,0,0,0,1.12,1.55c.49.33,2.43,1.33,2.86,1.58a2.52,2.52,0,0,0,1.17.36l0,.59,2.73,1.5,3.36-2-.11-2.65a12.27,12.27,0,0,0,3.3-3.68l0,0a8.45,8.45,0,0,0,1.11-4.46c-.06-1.49-.49-2.32-1.13-2.73S79,79.75,78.65,79.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,81.06A4.63,4.63,0,0,1,81.33,81c-.59-.36-2.31-1.24-2.68-1.47-.88-.55-2.16-.34-3.48,0L74,79.93h0a2.32,2.32,0,0,0-.26,1.13C73.83,82.76,75.74,81.71,77.9,81.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1,94.52l0,.59,2.73,1.5h0L74.75,94A6,6,0,0,1,72.1,94.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.68,92.54,67,91a3,3,0,0,0,1.12,1.55c.47.32,2.24,1.23,2.78,1.54A3,3,0,0,1,69.68,92.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.05,86.15a.65.65,0,0,0-.62-.38,7.79,7.79,0,0,0-2.24.52l-.09,0a4.14,4.14,0,0,1-1.53,1.45,4.29,4.29,0,0,1-1,.48l1.19.65c.24,1,1.11,1.27,2.6.37s1.87-1.82,1.84-2.62A1.38,1.38,0,0,0,78.05,86.15Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "70.97 71.5 73.7 73.01 73.8 75.68 71.06 74.17 70.97 71.5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M73.72,73.61l.08,2.07s-1.65.68-3.42,3.79c-.08.13-.14.26-.2.38a8.39,8.39,0,0,0-1,4.27h0c.06,1.58.59,2.39,1.35,2.74l.2.08h0l.23.06.21,0h.08l.17,0A5.94,5.94,0,0,0,72.89,87c.25,0,.51-.12.77-.19l1.11-.33.42-.14a7.15,7.15,0,0,1,2.24-.52.65.65,0,0,1,.62.38,1.38,1.38,0,0,1,.1.5c0,.8-.45,1.78-1.84,2.62s-2.36.67-2.6-.37l-4,3.64c.72,2,2.45,2.53,5.07,1.42l.11,2.65,3.36-2-.11-2.65a12.27,12.27,0,0,0,3.3-3.68l0,0a8.45,8.45,0,0,0,1.11-4.46c-.14-3.51-2.32-3.37-4.64-2.7-2.16.65-4.07,1.7-4.14,0a3.11,3.11,0,0,1,1.79-2.65c1.75-1.06,2.49-.16,2.67.72l4.23-3.79A4.08,4.08,0,0,0,82,74.17a2.4,2.4,0,0,0-1.4-1,5.36,5.36,0,0,0-3.44.56L77,71,73.7,73Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.22 94.59 74.86 96.61 74.75 93.95 75.18 96.03 78.22 94.59",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.71,88.9l-4,3.64,3.77-3.19s.48,1.87,2.86-.08c-1.49.9-2.36.67-2.6-.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.45,75.34A4.08,4.08,0,0,0,82,74.17a2.4,2.4,0,0,0-1.4-1,2.7,2.7,0,0,1,1.52,2.27l-3.87,3.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.13 73.68 76.77 71.47 73.7 73.01 77.02 71.01 77.13 73.68",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.73,109.54c8.48-3.81,16-14.82,16-14.82C83.23,101.86,77.63,107.3,71.93,110c-5.47,2.63-10.34,2.44-13.72-.54C58.21,109.5,63.11,113.42,71.73,109.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,72.9c4.51-8,10.83-14.73,17.55-18,7-3.36,12.91-2.21,16.47,2.31,0,0-6-7.07-16.51-1.62S59.19,72.9,59.19,72.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image_2.f38c71d424d6b45e8b0ff44491732e0f.svg";
export { ForwardRef as ReactComponent };